import API from './../api';
import { TEAM_MEMBER_LIST_ENDPOINT, TEAM_MEMBER_BY_ID_ENDPOINT } from './../endpoints';

export default {
    namespaced: true,
    state() {
        return {
            teamMember: null,
        };
    },

    getters: {
        teamMember: (state) => state.teamMember,
    },

    mutations: {
        gotTeamMember(state, response) {
            state.teamMember = response.data;
        },
        updatedTeamMember(state, response) {
            state.teamMember = response.data;
        },
        resetTeamMember(state) {
            state.teamMember = null;
        }
    },

    actions: {
        async fetchTeamMember({ commit }, { id }) {
            commit('gotTeamMember', await API.get(TEAM_MEMBER_BY_ID_ENDPOINT(id)));
        },
        async createTeamMember({ commit }, payload) {
            const response = await API.post(TEAM_MEMBER_LIST_ENDPOINT(), payload);
            return response.data;
        },
        async updateTeamMember({ commit }, { id, ...payload }) {
            commit(
                'updatedTeamMember',
                await API.patch(TEAM_MEMBER_BY_ID_ENDPOINT(id), payload)
            );
        },
        async updateTeamMemberPropertyPermissions({ commit }, { id, ...payload }) {
            commit(
                'updatedTeamMember',
                await API.post(TEAM_MEMBER_BY_ID_ENDPOINT(id, 'properties-set-limited'), payload)
            );
        },
        async updateTeamMemberPropertiesSave({ commit }, { id, data }) {
            commit(
                'updatedTeamMember',
                await API.post(TEAM_MEMBER_BY_ID_ENDPOINT(id, 'properties-save'), data)
            );
        },
        async updateTeamMemberPropertiesSaveAll({ commit }, { id, data }) {
            commit(
                'updatedTeamMember',
                await API.post(TEAM_MEMBER_BY_ID_ENDPOINT(id, 'properties-save-all'), data)
            );
        },
        async updateAccess({ commit }, { id, ...payload }) {
            commit(
                'updatedTeamMember',
                await API.put(TEAM_MEMBER_BY_ID_ENDPOINT(id, 'access'), payload)
            )
        },
        async sendEmail(_, { id, ...payload }) {
            const data = new FormData();
            Object.entries(payload).forEach(([key, value]) => {
                if (value) {
                    data.append(key, value);
                }
            })

            await API.post(TEAM_MEMBER_BY_ID_ENDPOINT(id, 'send-email'), data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
    },

};
